import React, { FunctionComponent } from 'react';
import { Typography } from '@mui/material';
import moment from 'moment';

import { IPenaltyWaiver } from '../../../../store/V2/PenaltyWaiverSlice';
import { StyledTableCell, StyledTableRow } from '../../Table/type1/TableStyles';

interface PenaltyWaiverTableRowProps {
  penaltyWaiver: IPenaltyWaiver;
}

const PenaltyWaiverTableRow: FunctionComponent<PenaltyWaiverTableRowProps> = ({
  penaltyWaiver,
}) => {
  const createdAt = moment(penaltyWaiver.createdAt);

  return (
    <StyledTableRow hover key={penaltyWaiver._id}>
      <StyledTableCell>
        <Typography fontSize="14px" fontWeight={500} color="#1E293B">
          {createdAt.format('DD MMM YYYY')}
        </Typography>
        <Typography fontSize="12px" color="#94A3B8">
          {createdAt.format('hh:mm A')}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        <Typography
          fontSize="14px"
          fontWeight={500}
          color="#1E293B"
          textTransform="capitalize"
        >
          {penaltyWaiver.type.toLowerCase()}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        <Typography
          fontSize="14px"
          fontWeight={500}
          color="#1E293B"
          textTransform="capitalize"
        >
          {penaltyWaiver.currency} {penaltyWaiver.amount.toFixed(2)}
        </Typography>
      </StyledTableCell>
    </StyledTableRow>
  );
};

export default PenaltyWaiverTableRow;
